import { UploadOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row, Upload } from "antd";
import { RcFile } from "antd/es/upload";
import { UploadMedia } from "../../../utils/imageUpload";
import { useEffect, useState } from "react";
import {
  useLazyGetBrandByIdQuery,
  usePostBrandMutation,
  useUpdateBrandByIdMutation,
} from "../../../services/main";
import { showError, showToast } from "../../../helpers/toast";
import { useNavigate, useParams } from "react-router-dom";
import { ImageViewer } from "../../../components";
import { isValidInput } from "../../../utils/validations";

const { TextArea } = Input;

let imageId = 0;
const FormData = (props: any) => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const [addBrand, addBrandLoader] = usePostBrandMutation();
  const [editBrand, editBrandLoader] = useUpdateBrandByIdMutation();
  const [getBrandById] = useLazyGetBrandByIdQuery();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const [imageObject, setImageObject] = useState<RcFile | null>(null);
  const [imagePreview, setImagePreview] = useState("");

  const handleImageUpload = async () => {
    try {
      const res = await UploadMedia(imageObject);
      if (res?.code === 200) {
        return res?.data[0]?.id;
      }
      return 0;
    } catch (error: any) {
      console.log(error);
      return 0;
    }
  };

  const onFinish = async (values: any) => {
    console.log("Received values of form: ", values);
    if (imageObject) {
      imageId = await handleImageUpload();
    }
    const body = {
      name,
      brand_logo_id: imageId || 0,
      description,
    };
    try {
      let response = null;
      if (id && id !== "add") {
        response = await editBrand({ body, brand_id: `${id}` }).unwrap();
      } else {
        response = await addBrand(body).unwrap();
      }
      console.log(response);
      if (response?.code === 201 || response?.code === 200) {
        showToast(response?.message || "");
        navigate("/manage-brands", { replace: true });
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      console.log(error);
    }
  };

  const onFinishFailed = ({ values, errorFields, outOfDate }: any) => {
    console.log(
      values,
      errorFields,
      outOfDate,
      "values, errorFields, outOfDate"
    );
  };

  const handleUpload = (File: RcFile) => {
    setImageObject(File);
    const result = window.URL.createObjectURL(File);
    setImagePreview(result);
  };

  const getBrandDetails = async (id: string) => {
    const response = await getBrandById({ brand_id: id }).unwrap();
    if (response?.code === 201) {
      setName(response?.data?.name);
      setDescription(response?.data?.description);
      setImagePreview(response?.data?.brand_logo?.media_file_url);
      imageId = response?.data?.brand_logo?.id;

      form.setFieldsValue({
        brand_name: response?.data?.name,
        description: response?.data?.description,
        image: imageId,
      });
    }
  };

  useEffect(() => {
    if (id && id !== "add") {
      getBrandDetails(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div>
      <Form form={form} onFinish={onFinish} onFinishFailed={onFinishFailed}>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="image"
              rules={[
                {
                  required: true,
                  message: "Please enter brand logo.",
                },
              ]}
            >
              {imagePreview ? (
                <ImageViewer
                  source={imagePreview}
                  resetImage={() => {
                    setImageObject(null);
                    setImagePreview("");
                    imageId = 0;
                  }}
                />
              ) : (
                <Upload
                  name="logo"
                  beforeUpload={handleUpload}
                  accept="image/png, image/gif, image/jpeg"
                >
                  <h4>Upload Brand Logo</h4>
                  <Button icon={<UploadOutlined />}>Click to upload</Button>
                </Upload>
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="brand_name"
              rules={[
                {
                  required: true,
                  message: "Please enter brand name.",
                },
                {
                  min: name?.length ? 1 : 2,
                  message: "Please enter brand name.",
                },
              ]}
            >
              <div>
                <h4>Name</h4>
                <Input
                  value={name}
                  onChange={(val) => {
                    if (isValidInput(val.target.value)) {
                      setName(val.target.value);
                    }
                  }}
                  placeholder="Name"
                  style={{ height: 55 }}
                  maxLength={50}
                />
              </div>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="description"
              rules={[
                {
                  required: true,
                  message: "Please enter category description.",
                },
                {
                  min: description?.length ? 1 : 2,
                  message: "Please enter category description.",
                },
              ]}
            >
              <div>
                <h4>Description</h4>
                <TextArea
                  value={description}
                  onChange={(val) => {
                    if (isValidInput(val.target.value)) {
                      setDescription(val.target.value);
                    }
                  }}
                  rows={10}
                  placeholder="Description"
                />
              </div>
            </Form.Item>
          </Col>
        </Row>

        <div className="submit-btn-wrapper">
          <Button
            className="submit-btn-container"
            type="primary"
            htmlType="submit"
            loading={addBrandLoader?.isLoading || editBrandLoader?.isLoading}
          >
            {props?.path ? "Update" : "Add"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default FormData;
